import { Button, UIText3, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { NBSP } from 'shared/constants/common';
import styles from './styles.css';

interface ICreditInfoModalFooterProps {
  handleFillApplicationClick: () => void;
  isPending?: boolean;
  buttonText?: string;
  variant?: 'default' | 'redesign';
  testId?: string;
}

export const CreditInfoModalFooter: React.FC<ICreditInfoModalFooterProps> = ({
  handleFillApplicationClick,
  isPending,
  buttonText,
  variant = 'default',
  testId,
}) => {
  const deviceType = useDeviceType();
  const isRedesign = variant === 'redesign';

  return (
    <div className={cn(styles.container, styles[deviceType], isRedesign && styles.redesign)}>
      <Button
        size="L"
        onClick={handleFillApplicationClick}
        loading={isPending}
        fullWidth={deviceType === 'phone'}
        data-testid={testId}
      >
        {buttonText || (isRedesign ? 'Заполнить анкету на Циане' : 'Заполнить заявку на Циане')}
      </Button>
      {/* buttonText есть только у ТБанка, кнопка ведет на их сайт, поэтому не нужно показывать регуляторный текст */}
      {!buttonText && (
        <div className={cn(styles['text-container'], styles[deviceType])}>
          {isRedesign ? (
            <UIText3 color="text-secondary-default" textAlign={deviceType === 'phone' ? 'center' : 'right'}>
              {`Анкета${NBSP}— единая для всех банков. Не оферта.`}
            </UIText3>
          ) : (
            <>
              <UIText3 color="text-secondary-default" textAlign={deviceType === 'phone' ? 'center' : 'right'}>
                {`Заявка${NBSP}— единая для всех банков. Не оферта.`}
              </UIText3>
              <UIText3 color="text-secondary-default" textAlign={deviceType === 'phone' ? 'center' : 'right'}>
                {`Перед заполнением попросим авторизоваться.`}
              </UIText3>
            </>
          )}
        </div>
      )}
    </div>
  );
};
